export default {
    name: {
        type: String,
        required: true,
    },
    cssClass: {
        type: String,
        dafault: ''
    }
}